var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-player"},[_c('vx-modal',{ref:"banner__video",attrs:{"size":"large"}},[_c('div',{staticClass:"player-container embed-responsive embed-responsive-16by9",attrs:{"slot":"component"},slot:"component"},[_c('vx-youtube-player',{attrs:{"src":_vm.videoSRCWithOptions,"width":"100%","height":"350"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65fa045c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/common/vx-video-player/vx-video-player.html
// module id = null
// module chunks = 